import { useEffect } from "react";
import { plgNavigation } from "plg/api/plgApi";

/**
 * Back/Forward can restore a whole page from the browser's back/forward cache without running any
 * code, e.g. the app after a session ended with a full page load. On such a restore, re-check and
 * leave to `to` (replacing the entry) when `mustLeave()` says this page is no longer allowed.
 */
export default function useRecheckOnRestore(mustLeave: () => boolean, to: string): void {
  useEffect(() => {
    const onPageShow = (e: PageTransitionEvent) => {
      if (e.persisted && mustLeave()) plgNavigation.replace(to);
    };
    window.addEventListener("pageshow", onPageShow);
    return () => window.removeEventListener("pageshow", onPageShow);
  }, [mustLeave, to]);
}
